// extracted by mini-css-extract-plugin
module.exports = {"siteHeader":"Header-module__siteHeader","hasNewNav":"Header-module__hasNewNav","custommobileHeader":"Header-module__custommobileHeader"};